import firebase from 'firebase/app';
import 'firebase/analytics';
import 'firebase/auth';
import 'firebase/firestore';
import 'firebase/functions';
import 'firebase/performance';
import 'firebase/storage';
import 'firebase/messaging';
import { firebaseConfig } from './config';
import { isLocalDevelopment } from '../utils/environment';

export const firebaseApp = firebase.initializeApp(firebaseConfig);

export const firestore = firebaseApp.firestore();
firestore.enablePersistence();

export const firebaseFunctions = firebaseApp.functions('europe-west1');
if (isLocalDevelopment()) firebaseFunctions.useFunctionsEmulator('http://localhost:5000');

export const firebasePerformance = firebaseApp.performance();
firebasePerformance.instrumentationEnabled = true;
firebasePerformance.dataCollectionEnabled = true;

export const firebaseAuth = firebaseApp.auth();

export function combineIdsAndValues<T extends { id: string; deleted?: true }>({
  ids,
  value
}: {
  ids: string[];
  value: T[];
}) {
  return value.map((doc, index) => ({ ...doc, id: ids[index] })).filter(doc => !doc.deleted);
}
